module.exports = __webpack_public_path__ + "images/assets/fc8521f69bdf2d2ed1a5b9aa7edd95c7.svg";